export const ROOT = '/'
export const AUTH = '/provider-auth'
export const LOGIN = '/login'
export const CONFIG = '/config'
export const POPUP_URL = '/sheetgo_auth'
export const REMOVE = '/remove'

// Addin routes
export const ADDIN = '/addin'